const _import = name => {
  return resolve => require([`../../views/${name}`], resolve)
}

const myChild = {
  path: '/My',
  component: _import('My'),
  children: [{
      meta: { navShow: true, titleHide: true, isRefreshAccount: true, requireAuth:true, isContact: true, title: '我的'},
      path: '',
      name: 'MyBase',
      component: _import('My/Base'),
    },
    {
      path: 'bet-record',
      name: 'BetRecord',
      meta: { navShow: false, titleHide: true,requireAuth:true,title: '投注记录'},
      // component: _import('My/BetRecord'),
      component: _import('My/BetRecord/search'),
      // children:[
      //   {
      //     path: '',
      //     meta: { navShow: false ,titleHide:true },
      //     component: _import('My/BetRecord/search.vue'),
      //   },
      //   {
      //     path: 'betRecord',
      //     meta: { navShow: false ,titleHide:true },
      //     name: 'betRecord',
      //     component: _import('My/BetRecord/betRecord.vue'),
      //   },
      // ]
    },
    {
      path: 'latest-deposit',
      name: 'LatestDeposit',
      meta: { navShow: false, titleHide: true,requireAuth:true,title: '存款订单记录'},
      component: _import('My/LatestDeposit'),
    },
    {
      path: 'merch-record',
      redirect: '/My/merch-record/merchRecord',
      meta: { navShow: false, titleHide: true,requireAuth:true,title: '交易记录'},
      component: _import('My/MerchRecord'),
      children:[
        // { // 交易详情
        //   path: 'merchDetail',
        //   meta: { navShow: false ,titleHide:true },
        //   name: 'merchDetail',
        //   component: _import('My/MerchRecord/merchDetail'),
        // },
        {
          path: 'merchRecord',
          meta: { navShow: false ,titleHide:true },
          name: 'merchRecord',
          component: _import('My/MerchRecord/merchRecord'),
        },
      ]
    },
    {
      path: 'lock-amount',
      meta: { navShow: false,titleHide:true,requireAuth:true,title: '资金锁定明细'},
      name: 'LockAmount',
      component: _import('My/LockAmount')
    },
    {
      path: 'game-collect',
      meta: { navShow: false,titleHide:true,requireAuth:true,title: '我的收藏'},
      name: 'gameCollect',
      component: _import('game/collect/'),
    },
    {
      path: 'InviteFriends',
      meta: { navShow: false,titleHide:true,requireAuth:true,title: '邀请好友'},
      name: 'InviteFriends',
      component: _import('My/InviteFriends'),
    },
    {
      path: 'Withdrawal',
      name: 'Withdrawal',
      redirect: '/My/Withdrawal/withdrawal',
      // redirect: '/withdraw/audit',
      meta: { navShow: false, titleHide: true,requireAuth:true,title: '取款'},
      component: _import('My/Withdrawal'),
      children:[
        { // 银行卡管理
          path: 'addbankcard',
          meta: { navShow: false ,titleHide:true },
          name: 'addbankcard',
          component: _import('My/Withdrawal/addbankcard'),
        },
        { // 取款
          path: 'bankDetail',
          meta: { navShow: false ,titleHide:true },
          name: 'bankDetail',
          component: _import('My/Withdrawal/bankDetail.vue'),
        },
        {
          path: 'withdrawal',
          meta: { navShow: true ,titleHide:true },
          name: 'withdrawal',
          component: _import('My/Withdrawal/withdrawal'),
        },
      ]
    },
    {
      path: 'AccountManat',
      redirect: '/My/AccountManat',
      meta: { navShow: false, titleHide: true,requireAuth:true,title: '账号管理'},
      component: _import('My/AccountManat'),
      children:[
        {
          path: '',
          meta: { navShow: false ,titleHide:true },
          name: 'accountmanat',
          component: _import('My/AccountManat/accountmanat'),
        },
        { // 邮箱认证
          path: 'emailAuth',
          meta: { navShow: false ,titleHide:true },
          name: 'emailAuth',
          component: _import('My/AccountManat/emailAuth'),
        },
        { // 邮箱认证
          path: 'VerifiedAuth',
          meta: { navShow: false ,titleHide:true },
          name: 'VerifiedAuth',
          component: _import('My/AccountManat/VerifiedAuth'),
        },
        { // 手机号认证
          path: 'mobileAuth',
          meta: { navShow: false ,titleHide:true },
          name: 'mobileAuth',
          component: _import('My/AccountManat/mobileAuth'),
        },
        { // 登录密码
          path: 'loginPossword',
          meta: { navShow: false ,titleHide:true },
          name: 'loginPossword',
          component: _import('My/AccountManat/loginPossword2'),
        },
        { // 提款密码
          path: 'WithdrawPasword',
          meta: { navShow: false ,titleHide:true },
          name: 'WithdrawPasword',
          // component: _import('My/AccountManat/WithdrawPasword'),
          component: _import('My/AccountManat/WithdrawPasword2'),
        },
        { // 提款密码
          path: 'WithdrawPasword2',
          meta: { navShow: false ,titleHide:true },
          name: 'WithdrawPasword2',
          component: _import('My/AccountManat/WithdrawPasword'),
        },
      ]
    },

    // {
    //   path: 'StationLetter',
    //   name: 'StationLetter',
    //   meta: { navShow: false, titleHide: true,requireAuth:true,title: '站内信'},
    //   component: _import('My/StationLetter'),
    // },
    {
      path: 'Wallet',
      name: 'Wallet',
      meta: { navShow: false, titleHide: true, diffBg2: true, requireAuth:true,title: '钱包'},
      component: _import('My/Wallet'),
    },
    // {
    //   path: 'BankManageMent',
    //   name: 'BankManageMent',
    //   meta: { navShow: false, titleHide: true, diffBg2: true, requireAuth:true,title: '银行卡管理'},
    //   component: _import('My/BankManageMent'),
    // }
  ]
}

export default myChild



// WEBPACK FOOTER //
// ./src/pages/build821/router/module/My.js